import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TurnMeUp from '../common/TurnMeUp.js';
import WidgetService from '../../services/widgetService.js';

class ChartVideoItem extends Component {
    constructor(props, context) {
        super(props, context);
        this.setRef = this.setRef.bind(this);
        this.playVideo = this.playVideo.bind(this);
    }

    componentDidMount() {
        WidgetService.initialiseMagnific($(this.videoAnchor));
    }

    playVideo(event) {
        //log the video play    
        this.props.actions.playVideo(this.props.video.ID);
    }    

    setRef(anchor) {
        this.videoAnchor = anchor;
    }

    render() {        
        let video = this.props.video;
        return (
             <li>
                <div className="item-content">
                    <p className="no">{this.props.index + 1}</p>                   
                    <div className="videolink" title={video.Description}>
                        <a href={video.Url} className="magnific" onClick={this.playVideo} title={video.Description} ref={this.setRef}>
                            <div className="imgbox">
                                <span className="btn-playlarge">
                                    <span className="outcircle transition2" />
                                    <svg className="icon icn-play transition">
                                        <use xlinkHref="#icn-play" />
                                    </svg>
                                </span>
                                <img src={video.ImageUrl} />
                            </div>                   
                        </a>  
                    </div>
                    <h2 style={{color: '#333'}}>{video.Name}</h2>     
                    <p className="by">
                        By: <Link to={`/${video.RoleUsername}`} className="transition link">{video.RoleDisplayName}</Link>
                    </p>
                </div>
                <div className="item-turnup">
                    <div className="loudtrend">
                        <p className="trend up">{video.TrendingRating}</p>
                        <span>
                            <TurnMeUp id={video.ID} rating={video.Rating} roleID={video.RoleID} isMusic={false} />
                        </span>   
                    </div>
                </div>
            </li>
        );
    }
}

ChartVideoItem.propTypes = {
    video: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

export default ChartVideoItem;